import { ActionGroup, ActionItem } from '../types';

const mergeActionItems = (actionGroups: ActionGroup[]) => {
  let toReturn: ActionItem[] = [];
  actionGroups.forEach(actionGroup => {
    toReturn.push(...actionGroup?.action_items);
  });
  return toReturn;
};

export default mergeActionItems;
